import React, { Component } from 'react';
import PutBodyParam from './putBodyParam';
import ShowBodyParams from './showBodyParams';
import ShowDiagram from './showDiagramAll';
import Service from '../../services/bodyParams';

export default class BodyParams extends Component {
  state = {
    bodyParams: null,
    allBodyParams: null,
    gender: null,
    age: null,
    bmi: []
  };

  componentDidMount() {
    this.updateData();
  }

  updateData = () => {
    Service.getActualBodyParams().then(
      (response) => {
        this.setState({
          bodyParams: response.data,
        });
      },
      (error) => {
        console.error("Error fetching body parameters:", error);
      }
    );

    Service.getAllBodyParams().then(
      (response) => {
        this.setState({
          allBodyParams: response.data,
        });
      },
      (error) => {
        console.error("Error fetching body parameters:", error);
      }
    );

    Service.getGender().then(
      (response) => {
        this.setState({
          gender: response.data.gender,
        });
      },
      (error) => {
        console.error("Error fetching gender:", error);
      }
    );

    Service.getAge().then(
      (response) => {
        this.setState({
          age: response.data.age,
        });
      },
      (error) => {
        console.error("Error fetching age:", error);
      }
    );

    Service.getBmiParams()
      .then((response) => {
        if (Array.isArray(response.data)) {
          const bmiData = response.data.map(item => ({
            ...item,
            date: item.date ? new Date(item.date).toISOString().split('T')[0] : null
          }));
          this.setState({ bmi: bmiData });
        } else {
          this.setState({ bmi: [] });
        }
      })
      .catch((error) => {
        console.error("Błąd pobierania BMI:", error);
        this.setState({ bmi: [] });
      });
  };



  render() {
    return (
      <div className="card-container">
        <ShowBodyParams
          bodyParams={this.state.bodyParams}
          gender={this.state.gender}
          age={this.state.age}
          bmi={this.state.bmi}
          updateData={this.updateData}
        />
        <PutBodyParam clientId={null} updateData={this.updateData} />
        <ShowDiagram allBodyParams={this.state.allBodyParams} />
      </div>
    );
  }
}
